/**
 * @generated SignedSource<<373a6e8c2336d2ea6428c41faa61cca1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectExtendElementForms_ElementV2Fragment$data = {
  readonly elementType: ElementTypeV2;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment">;
  readonly " $fragmentType": "ProjectExtendElementForms_ElementV2Fragment";
};
export type ProjectExtendElementForms_ElementV2Fragment$key = {
  readonly " $data"?: ProjectExtendElementForms_ElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExtendElementForms_ElementV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectExtendElementForms_ElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elementType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RandomMultipleChoiceElementForm_RandomMultipleChoiceElementFragment"
    }
  ],
  "type": "ElementV2",
  "abstractKey": "__isElementV2"
};

(node as any).hash = "7fb4549f2c24afeda7d29292aa036778";

export default node;
